import LogRocket from 'logrocket';

export const init = () => LogRocket.init(process.env.REACT_APP_LOGROCKET_ID);

export const identify = user => {
  LogRocket.identify(user.id, {
    name: user.name,
  });
};



// WEBPACK FOOTER //
// ./src/common/util/logger.js